import { HttpClient, HttpParams } from '@angular/common/http';
import {
  SimilarProjectsRequest,
  SimilarProjectsResponse,
} from '../../../shared/interfaces/similar-projects.interface';
import { EventEmitter, Inject, Injectable } from '@angular/core';
import { EnvironmentConfig } from '../../../shared/interfaces/environment.interface';

@Injectable({
  providedIn: 'root',
})
export class SimilarProjectsService {
  private _similarProjectPayload$ = new EventEmitter<SimilarProjectsRequest>();
  private readonly _baseUrl = this._env.environment.pureSpectrum.url;

  constructor(
    @Inject('ENV') private _env: EnvironmentConfig,
    private _http: HttpClient
  ) {}

  public getSurveys(
    payload: SimilarProjectsRequest,
    globalSearch: boolean = false
  ) {
    const url = `${this._baseUrl}/buyers/v2/similar-projects`;
    let params = new HttpParams();
    if (globalSearch) {
      params = params.set('global', '1');
    }
    return this._http.post<SimilarProjectsResponse[]>(url, payload, { params });
  }

  public getSimilarProjectPayload() {
    return this._similarProjectPayload$.asObservable();
  }

  public setSimilarProjectPayload(payload: SimilarProjectsRequest) {
    this._similarProjectPayload$.next(payload);
  }
}
